import GenerateCategories from './GenerateCategories';

export default GenerateCategories;
